module.exports = __webpack_public_path__ + "static/media/visual-timer-nick.4382d320.svg";